import * as React from 'react';
import * as moment from 'moment';

import { ICalendarState, IEventMonth, CalendarActions } from "@adage/ace-calendar";
import { IArenaEvent} from "../classes/event";
import { connect } from "react-redux";
import MonthSelection from './month-selection';
import ProductionSelection from './production-selection'
import AccessibilitySelection from '../components/accessibility-selection';
import CategoryFilter from '../components/category-filter';
import FilterTrigger from './filter-trigger';


interface FiltersExternalProps {
    numberOfMonth: number
    isMobile: boolean;
    invalidMonths: Array<moment.Moment>;
}


interface FilterState
{
    clearing: boolean;
}


class filters extends React.Component<FiltersExternalProps, FilterState> {
    constructor(props)
    {
        super(props);
        this.state = { clearing:true }
    }

    

    clear(evt: React.MouseEvent<HTMLButtonElement>) {

        CalendarActions.updateEventFilter({
            key: "category",
            filter: () => true
        });   

        CalendarActions.updateEventFilter({
            key: "productionFilter",
            filter: () => true
        })

        CalendarActions.updateEventFilter({
            key: "accessibility",
            filter: () => true
        })   

        this.setState({ clearing : !this.state.clearing })

    }

    render() {
        return (
            <div id="filter-menu" className="cal-filters-container">
                <div className="cal-filters-inner">
                    <div className="cal-filters-clear-container">
                        <h2 className="cal-filters-category-title">Filters</h2>
                        <div>
                            <button className="cal-filters-clear" type="button" onClick={this.clear.bind(this)}>Clear All</button>
                        </div>
                    </div>
                    <header className={`cal-header`}>
                        <nav>
                            <FilterTrigger />
                            <MonthSelection numberOfMonths={this.props.numberOfMonth} isMobile={this.props.isMobile} invalidMonths={this.props.invalidMonths} />
                        </nav>
                    </header>
                    <nav id="filter-nav" className="cal-nav">
                        <div className="cal-nav-inner">
                            <div className="cal-nav-filters">
                                <CategoryFilter shouldClear={this.state.clearing} isMobile={this.props.isMobile}/>
                                <ProductionSelection shouldClear={this.state.clearing} isMobile={this.props.isMobile} numberOfMonth={this.props.numberOfMonth}/>
                                <AccessibilitySelection shouldClear={this.state.clearing} isMobile={this.props.isMobile} />
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        );
    }
}




export default (filters);


// WEBPACK FOOTER //
// ./app/calendar/components/Filter.tsx